import { PageBarLayoutProps } from "./PageBarLayout.types";

/**
 * Shared header-bar layout every entity page bar builds on: back button,
 * then a space for identity (avatar/name/email), badges, action buttons,
 * and menu icons, in that order, wrapping on narrow screens.
 */
export function PageBarLayout({
  backButton,
  identity,
  badges,
  centre,
  actions,
  menu,
}: PageBarLayoutProps) {
  // With a centre, the two sides share the rest equally so it sits in the middle.
  const side = centre ? "flex-md-grow-1 flex-basis-md-0" : "";

  return (
    <div
      id="header-bar"
      className="d-flex flex-wrap align-items-center gap-3 p-2 px-md-3"
    >
      <div
        className={`d-flex flex-wrap align-items-center gap-3 row-gap-2 ${side}`}
      >
        {backButton}
        {identity}
        {badges && (
          <div className="d-flex align-items-center gap-2 flex-basis-100 flex-basis-md-auto">
            {badges}
          </div>
        )}
      </div>
      {centre && (
        <div className="d-flex align-items-center gap-2">{centre}</div>
      )}
      <div
        className={`d-flex align-items-center gap-2 ms-auto ${side} ${
          centre ? "justify-content-end" : ""
        }`}
      >
        {actions}
        {menu}
      </div>
    </div>
  );
}

export default PageBarLayout;
